import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import StyledCrossButton from "./styles";

const CrossButton = ({ className, fontSize = "medium", onClick }) => {
  return (
    <StyledCrossButton className={className} onClick={onClick}>
      <div className="cross-button">
        <CloseIcon fontSize={fontSize} sx={{ fill: "white" }} />
      </div>
    </StyledCrossButton>
  );
};

export default CrossButton;
